import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// locals
import { getSOTermAndDescription } from './util';
var VCFFeature = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function VCFFeature(args) {
    _classCallCheck(this, VCFFeature);
    this.variant = args.variant;
    this.parser = args.parser;
    this.data = this.dataFromVariant(this.variant);
    this._id = args.id;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _createClass(VCFFeature, [{
    key: "get",
    value: function get(field) {
      return field === 'samples' ? this.variant.SAMPLES : this.data[field] || this.variant[field];
    }
  }, {
    key: "set",
    value: function set() {}
  }, {
    key: "parent",
    value: function parent() {
      return undefined;
    }
  }, {
    key: "children",
    value: function children() {
      return undefined;
    }
  }, {
    key: "tags",
    value: function tags() {
      return [].concat(_toConsumableArray(Object.keys(this.data)), _toConsumableArray(Object.keys(this.variant)), ['samples']);
    }
  }, {
    key: "id",
    value: function id() {
      return this._id;
    }
  }, {
    key: "dataFromVariant",
    value: function dataFromVariant(variant) {
      var REF = variant.REF,
        ALT = variant.ALT,
        POS = variant.POS,
        CHROM = variant.CHROM,
        INFO = variant.INFO,
        ID = variant.ID;
      var start = POS - 1;
      var _getSOTermAndDescript = getSOTermAndDescription(REF, ALT, this.parser),
        _getSOTermAndDescript2 = _slicedToArray(_getSOTermAndDescript, 2),
        type = _getSOTermAndDescript2[0],
        description = _getSOTermAndDescript2[1];
      var isTRA = ALT === null || ALT === void 0 ? void 0 : ALT.some(function (f) {
        return f === '<TRA>';
      });
      var isSymbolic = ALT === null || ALT === void 0 ? void 0 : ALT.some(function (f) {
        return f.indexOf('<') !== -1;
      });
      return {
        refName: CHROM,
        start: start,
        end: isSymbolic && INFO.END && !isTRA ? +INFO.END[0] : start + REF.length,
        description: description,
        type: type,
        name: ID === null || ID === void 0 ? void 0 : ID.join(','),
        aliases: ID && ID.length > 1 ? variant.ID.slice(1) : undefined
      };
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "toJSON",
    value: function toJSON() {
      return _objectSpread({
        uniqueId: this._id
      }, this.variant, this.data, {
        samples: this.variant.SAMPLES
      });
    }
  }]);
  return VCFFeature;
}();
export { VCFFeature as default };